import styles from './virtual-assistant-button.module.scss';
import Icon, { IconProps } from '@/components/common/iconedLinks/Icon';
import { useTranslation } from 'next-i18next';
import { URLS } from '@/constants/urls';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

type Props = {
  label?: string;
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  size: 'sm' | 'md';
  onClick?: (changes: string) => void;
  icon?: IconProps
};

export const VirtualAssistantButton = ({
  label = '',
  variant = 'primary',
  size = 'md',
  disabled,
  onClick,
  icon
}: Props) => {
  const { t } = useTranslation('alter');
  const isMobile = useScreenSizeContext().isMobile;
  const className = [
    styles.button,
    styles[variant],
    isMobile ? styles.sm : styles[size],
    disabled ? styles.disabled : '',
  ]
    .filter(Boolean)
    .join(' ');

  const handleClick = () => {
    return onClick?.(label);
  };

  const iconSize = isMobile || size === 'sm' ? 16 : 24;

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={handleClick}
      className={className}
    >
      {variant === 'primary' && (
        <Icon src={icon?.src || URLS.SPARKLES_STARS_WHITE} alt={t('icon')} height={iconSize} width={iconSize} />
      )}
      {label && (
        <span className={styles.label}>{label}</span>
      )}
    </button>
  );
};
